import * as React from 'react';
import { AppContext } from '../../Context/app-state';
import './Garland.css';

export default function Garland() {
  const { garlandSettings } = React.useContext(AppContext);
  const countLight = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];
  const row1 = countLight
    .slice(0, 2)
    .map(() => <li className={`${garlandSettings.colorGarland}`} />);
  const row2 = countLight
    .slice(0, 3)
    .map(() => <li className={`${garlandSettings.colorGarland}`} />);
  const row3 = countLight
    .slice(0, 4)
    .map(() => <li className={`${garlandSettings.colorGarland}`} />);
  const row4 = countLight
    .slice(0, 5)
    .map(() => <li className={`${garlandSettings.colorGarland}`} />);
  const row5 = countLight
    .slice(0, 6)
    .map(() => <li className={`${garlandSettings.colorGarland}`} />);
  const row6 = countLight
    .slice(0, 7)
    .map(() => <li className={`${garlandSettings.colorGarland}`} />);
  const row7 = countLight
    .slice(0, 8)
    .map(() => <li className={`${garlandSettings.colorGarland}`} />);
  const row8 = countLight
    .slice(0, 9)
    .map(() => <li className={`${garlandSettings.colorGarland}`} />);
  const row9 = countLight
    .slice(0, 10)
    .map(() => <li className={`${garlandSettings.colorGarland}`} />);
  const row10 = countLight
    .slice(0, 11)
    .map(() => <li className={`${garlandSettings.colorGarland}`} />);
  const row11 = countLight
    .slice(0, 12)
    .map(() => <li className={`${garlandSettings.colorGarland}`} />);
  const row12 = countLight
    .slice(0, 13)
    .map(() => <li className={`${garlandSettings.colorGarland}`} />);
  const row13 = countLight
    .slice(0, 14)
    .map(() => <li className={`${garlandSettings.colorGarland}`} />);
  const row14 = countLight
    .slice(0, 15)
    .map(() => <li className={`${garlandSettings.colorGarland}`} />);
  const row15 = countLight
    .slice(0, 16)
    .map(() => <li className={`${garlandSettings.colorGarland}`} />);
  return (
    <div className="garland-tree-container">
      <ul
        className="lightrope"
        style={{
          display: garlandSettings.garland ? 'block' : 'none',
          width: 150,
          height: 150,
          top: -50,
        }}
      >
        {row1}
      </ul>
      <ul
        className="lightrope"
        style={{
          display: garlandSettings.garland ? 'block' : 'none',
          width: 170,
          height: 170,
          top: -10,
        }}
      >
        {row2}
      </ul>
      <ul
        className="lightrope"
        style={{
          display: garlandSettings.garland ? 'block' : 'none',
          width: 190,
          height: 190,
          top: 30,
        }}
      >
        {row3}
      </ul>
      <ul
        className="lightrope"
        style={{
          display: garlandSettings.garland ? 'block' : 'none',
          width: 210,
          height: 210,
          top: 70,
        }}
      >
        {row4}
      </ul>
      <ul
        className="lightrope"
        style={{
          display: garlandSettings.garland ? 'block' : 'none',
          width: 230,
          height: 230,
          top: 110,
        }}
      >
        {row5}
      </ul>
      <ul
        className="lightrope"
        style={{
          display: garlandSettings.garland ? 'block' : 'none',
          width: 250,
          height: 250,
          top: 150,
        }}
      >
        {row6}
      </ul>
      <ul
        className="lightrope"
        style={{
          display: garlandSettings.garland ? 'block' : 'none',
          width: 270,
          height: 270,
          top: 190,
        }}
      >
        {row7}
      </ul>
      <ul
        className="lightrope"
        style={{
          display: garlandSettings.garland ? 'block' : 'none',
          width: 290,
          height: 290,
          top: 240,
        }}
      >
        {row8}
      </ul>
      <ul
        className="lightrope"
        style={{
          display: garlandSettings.garland ? 'block' : 'none',
          width: 310,
          height: 310,
          top: 280,
        }}
      >
        {row9}
      </ul>
      <ul
        className="lightrope"
        style={{
          display: garlandSettings.garland ? 'block' : 'none',
          width: 330,
          height: 330,
          top: 320,
        }}
      >
        {row10}
      </ul>
      <ul
        className="lightrope"
        style={{
          display: garlandSettings.garland ? 'block' : 'none',
          width: 350,
          height: 350,
          top: 360,
        }}
      >
        {row11}
      </ul>
      <ul
        className="lightrope"
        style={{
          display: garlandSettings.garland ? 'block' : 'none',
          width: 370,
          height: 370,
          top: 400,
        }}
      >
        {row12}
      </ul>
      <ul
        className="lightrope"
        style={{
          display: garlandSettings.garland ? 'block' : 'none',
          width: 390,
          height: 390,
          top: 440,
        }}
      >
        {row13}
      </ul>
      <ul
        className="lightrope"
        style={{
          display: garlandSettings.garland ? 'block' : 'none',
          width: 410,
          height: 410,
          top: 480,
        }}
      >
        {row14}
      </ul>
      <ul
        className="lightrope"
        style={{
          display: garlandSettings.garland ? 'block' : 'none',
          width: 430,
          height: 430,
          top: 520,
        }}
      >
        {row15}
      </ul>
    </div>
  );
}
